import {Component, EventEmitter, Input, Output} from '@angular/core';
import {JsonPipe, NgClass, NgFor} from "@angular/common";
import {AvailableUserChoices, MessageStatus, STEP_STATUS, STEP_TYPE, ToolingType} from "../../../models/enums";
import {TranslateModule} from "@ngx-translate/core";
import {ActivatedRoute, Router} from "@angular/router";
import {lastValueFrom} from "rxjs";
import {ChatRepository} from "../../../repositories/chat.repository";
import {LoaderService} from "../../../services/loader.service";
import {RagRepository} from "../../../repositories/rag.repository";
import {Utilities} from "../../../utilities/utilities";
import {MarkdownComponent} from "ngx-markdown";
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-tool-selector',
  standalone: true,
  imports: [NgFor, TranslateModule, JsonPipe, NgClass, MarkdownComponent],
  templateUrl: './tool-selector.component.html',
  styleUrl: './tool-selector.component.css'
})
export class ToolSelectorComponent {
  @Input() message: any;
  @Input() chatId: any;
  @Output() functionCallEvent = new EventEmitter<{ functionName: string, args: any[] }>();

  constructor(private chatRepository: ChatRepository, private router: Router, private route: ActivatedRoute, public loaderService: LoaderService, public ragRepository: RagRepository) {
  }

  async ngOnInit(): Promise<void> {
    if (environment.autoSilentRag && this.message.messageStatus == MessageStatus.USER_CHOICE_PENDING && this.message.availableUserChoices.includes(AvailableUserChoices.RAG_SILENT)) {
      await this.autoTool(AvailableUserChoices.RAG_SILENT);
    }
    else if (environment.autoSilentPlanner && this.message.messageStatus == MessageStatus.USER_CHOICE_PENDING && this.message.availableUserChoices.includes(AvailableUserChoices.PLANNER_SILENT)){
      await this.autoTool(AvailableUserChoices.PLANNER_SILENT);
    }
  }

  async autoTool(tool: AvailableUserChoices) {
    let chatPut = await lastValueFrom(this.chatRepository.updateMessage(this.chatId, this.message.messageId, tool));
    if (chatPut.nextMessageId) {

      let new_message = await lastValueFrom(this.chatRepository.getMessage(this.chatId, chatPut.nextMessageId));
      this.functionCallEvent.emit({functionName: 'loadMessages', args: [this.chatId]});
      console.log(new_message);
    }
  }

  async toolSelector(tool: AvailableUserChoices, messageId: string): Promise<void> {
    console.log("req start");
    let chatPut = await lastValueFrom(this.chatRepository.updateMessage(this.chatId, messageId, tool));
    console.log("req end");
    if (chatPut.nextMessageId) {
      if (tool == AvailableUserChoices.RAG_EDITOR || tool == AvailableUserChoices.PLANNER_EDITOR) {
        this.loaderService.show();
        await new Promise(resolve => setTimeout(resolve, 200));
        this.message = await lastValueFrom(this.chatRepository.getMessage(this.chatId, messageId));
        await this.router.navigate([`/chat/${this.chatId}/${Utilities.convertTypeToUrl(tool)}/${this.message.tooling.toolingId}`]);
      } else {
        let new_message = await lastValueFrom(this.chatRepository.getMessage(this.chatId, chatPut.nextMessageId));
        this.functionCallEvent.emit({functionName: 'loadMessages', args: [this.chatId]});
        console.log(new_message);
      }

    }
  }

  protected readonly MessageStatus = MessageStatus;

  jumpToTool(userChoice: AvailableUserChoices, toolingId: string) {
    this.router.navigate([`/chat/${this.chatId}/${Utilities.convertTypeToUrl(userChoice)}/${this.message.tooling.toolingId}`]);
  }

  protected readonly STEP_TYPE = STEP_TYPE;
  protected readonly environment = environment;
  protected readonly STEP_STATUS = STEP_STATUS;
  protected readonly ToolingType = ToolingType;
}

